export default {"src":"/_next/static/media/PENN.a0b6ddb1.svg","height":18,"width":18};